export const PAGE_VIEW = {
  page_title: "",
  page_slug: "",
  page_path: "",
}